import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import shallow from 'zustand/shallow'

import PerText from '../Text'
import PerFlexRow from '../FlexRow'
import PerButtonCircle from '../ButtonCircle'
import { useSettingsModalStore } from './SettingsModalStore'

export const SettingsModalHeader: FC = () => {
  const { t } = useTranslation()
  const [toggleModal] = useSettingsModalStore((state) => [state.toggleModal], shallow)

  const handleClose = () => {
    toggleModal(false)
  }

  return (
    <>
      <PerFlexRow justify="space-between" align="middle">
        <PerFlexRow>
          <PerText fontSize="xl" color="primary">
            {t('settingsModal.title')}
          </PerText>
        </PerFlexRow>
        <PerButtonCircle size="large" icon="close_stroke" color="transparent" onClick={handleClose} testid="sm-modal-close" />
      </PerFlexRow>
    </>
  )
}
